import { IAplosApiRequestArgs } from "@/services/aplosApi";
import { isEmptyOrWhitespace } from "@/utils";
import { AplosFileCategory } from "./AplosFileCategory";



export interface IGetFileUploadUrlPayload {

    file_name: string,
    method_type: string,
    category: string
}

export interface GetFileUploadUrlArgsOptions {
    tenantId: string;
    userId: string;
    fileName: string;
    category: AplosFileCategory;
    methodType?: string;
}

export class GetFileUploadUrlArgs implements IAplosApiRequestArgs {

    public tenantId: string;
    public userId: string;
    public fileName: string;
    public category: AplosFileCategory;
    public methodType: string;

    constructor(options: GetFileUploadUrlArgsOptions) {
        if (isEmptyOrWhitespace(options.tenantId)) throw Error("tenantId is required");
        if (isEmptyOrWhitespace(options.userId)) throw Error("userId is required");
        if (isEmptyOrWhitespace(options.fileName)) throw Error("fileName is required");
        const methodType = options.methodType ?? "post";
        if (isEmptyOrWhitespace(methodType)) throw Error("methodType is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.fileName = options.fileName;
        this.category = options.category;
        this.methodType = methodType;
    }

}